module.exports = __webpack_public_path__ + "static/media/logo.9adf116f.png";